/** Transcript panel: show low-audio-quality nudge when metadata confidence is strictly below this (0–1). */
export const AUDIO_QUALITY_CONFIDENCE_THRESHOLD = 0.75 as const
